import React from 'react';
import { observable, action } from 'mobx';
import { observer } from 'mobx-react';
import styled from 'styled-components';
import { media } from 'legacyComponents/styled/styleUtils';

import {
  ModalTitle,
  ModalContentWrapper,
  Center,
} from 'legacyComponents/styled/lib';
import { Button } from 'components';

import { Modal } from 'apps/modals/views/modal';
import { modalStore } from 'apps/modals/app';
import { ProfileListItem } from 'apps/modals/connResultsModal/views/profileListItem';
import { InitiativeListItem } from 'apps/modals/connResultsModal/views/initiativeListItem';
import { ProjectListItem } from 'apps/modals/connResultsModal/views/projectListItem';

class ModalState {
  @observable tabs = [];
  @observable activeTab = '';
  @observable activeArrayAppIndex = 0;
  constructor(arrayApps) {
    arrayApps.forEach(arrayApp => {
      if (arrayApp.apps.length !== 0) {
        const tabName = `${
          arrayApp.apps[0].constructor.registryName.split('App')[0]
        }s`;
        this.tabs.push(tabName);
      } else {
        this.tabs.push('');
      }
    });
    // eslint-disable-next-line
    for (const [index, tab] of this.tabs.entries()) {
      if (tab !== '') {
        this.activeTab = tab;
        this.activeArrayAppIndex = index;
        return;
      }
    }
  }

  @action SetActiveTab = (tab, index) => {
    this.activeTab = tab;
    this.activeArrayAppIndex = index;
  };
}

@observer
export class ConnResultsModal extends Modal {
  UNSAFE_componentWillMount() {
    this.modal = new ModalState(modalStore.props.arrayApps);
    const { activeArrayAppIndex } = this.modal;
    const { manager } = modalStore.props.arrayApps[activeArrayAppIndex];
    if (manager.hasNextPage) {
      manager.loadMore();
    }
  }

  render() {
    const { arrayApps, modalTitle } = modalStore.props;
    const { tabs, activeTab, activeArrayAppIndex, SetActiveTab } = this.modal;

    const tabsList = [];

    if (tabs.length > 1) {
      // eslint-disable-next-line
      for (const [index, tab] of tabs.entries()) {
        if (tab === '') {
          // eslint-disable-next-line
          continue;
        }
        let displayName = tab;
        if (tab === 'Profiles') {
          displayName = 'People';
        }
        if (tab === 'Initiatives') {
          displayName = 'Organisations';
        }
        tabsList.push(
          <Tab
            active={tab === activeTab}
            onClick={() => SetActiveTab(tab, index)}
            key={tab}
          >
            {displayName}
            <span> ({arrayApps[index].manager.totalCount})</span>
          </Tab>,
        );
      }
    }
    let tabBar = '';
    if (tabsList.length > 0) {
      tabBar = <TabsWrapper>{tabsList}</TabsWrapper>;
    }

    const results = [];

    arrayApps[activeArrayAppIndex].forEach(app => {
      if (activeTab === 'Profiles') {
        results.push(<ProfileListItem profile={app} key={app.id} />);
      } else if (activeTab === 'Initiatives') {
        results.push(<InitiativeListItem initiative={app} key={app.id} />);
      } else if (activeTab === 'Projects') {
        results.push(<ProjectListItem project={app} key={app.id} />);
      }
    });

    let button = (
      <ButtonStyled
        variant='secondary'
        onClick={() => modalStore.ClearComponent()}
        text='Close'
      />
    );
    if (arrayApps[activeArrayAppIndex].manager.hasNextPage) {
      button = (
        <ButtonStyled
          appearance='plain'
          onClick={() => arrayApps[activeArrayAppIndex].manager.loadMore()}
          text='Show more'
        />
      );
    }

    return (
      <ModalWrapper>
        <ModalTitle>{`${modalTitle}`}</ModalTitle>
        <ModalContentWrapper>
          {tabBar}
          {results}
        </ModalContentWrapper>
        <Center>{button}</Center>
      </ModalWrapper>
    );
  }
}

const ModalWrapper = styled.div`
  padding: 0 ${props => props.theme.spacing.default};
`;

const TabsWrapper = styled.ul`
  box-shadow: inset 0 -2px 0 0 ${props => props.theme.color.wfGrey200};
`;

const Tab = styled.li`
  display: inline-block;
  font-size: ${props => props.theme.font.size.small};
  color: ${props =>
    props.active ? props.theme.color.primary : props.theme.color.wfGrey};
  padding: 19px 10px 16px;
  margin: 0 30px 0 0;
  box-shadow: ${props =>
    props.active && `inset 0 -2px 0 0 ${props.theme.color.primary}`};
  cursor: pointer;
  &:hover {
    color: ${props => props.theme.color.primary};
  }
  > span {
    color: ${props =>
      props.active ? props.theme.color.primary : props.theme.color.wfGrey500};
  }
  ${media.s`
    margin: 0 20px 0 0;
  `}
`;

const ButtonStyled = styled(Button)`
  margin: ${props => props.theme.spacing.default} 0;
`;
